import { RestrictedAPI } from '@fnol/library/src/api';
import { GenericObject } from '@fnol/library/src/lib';
import * as endpoints from './endpoints';

export const getCountries = () => RestrictedAPI.get(endpoints.countries());
export const getCitizenships = () => RestrictedAPI.get(endpoints.citizenship());
export const getCities = () => RestrictedAPI.get(endpoints.cities());
export const getPublicUtilities = () => RestrictedAPI.get(endpoints.publicUtilities());
export const getUnions = () => RestrictedAPI.get(endpoints.unions());
export const getPolicyDetails = (data: GenericObject) => RestrictedAPI.post(endpoints.policyDetails(), data);
export const getActivePoliciesList = (data: GenericObject) => RestrictedAPI.get(endpoints.activePoliciesList(), data);
export const submitTemporaryData = (data: GenericObject) => RestrictedAPI.post(endpoints.claimSubmit(), data);
export const getClaimConfirmation = (data: any) => RestrictedAPI.post(endpoints.claimConfirmation(), data);
export const getClaimConfirmationAnonymous = (data: any) =>
    RestrictedAPI.post(endpoints.claimConfirmationAnonymous(), data);
export const getDocList = (id: string) => RestrictedAPI.get(endpoints.documents(id));
export const submitDocuments = (data: any) => RestrictedAPI.post(endpoints.addDocuments(), data);
export const getInsuranceMethod = () => RestrictedAPI.get(endpoints.insuranceMethod());
export const getDamageTypes = () => RestrictedAPI.get(endpoints.damageTypes());
export const getUserData = () => RestrictedAPI.get(endpoints.userData());
export const getPersonRoles = () => RestrictedAPI.get(endpoints.personRoles());
export const getObjectType = () => RestrictedAPI.get(endpoints.objectType());
export const getCauses = (insuranceMethod: number, policyNumber: string, publicUtility: number) =>
    RestrictedAPI.get(endpoints.causes(insuranceMethod, policyNumber, publicUtility));
export const sendOneTimePassword = (data: any) => RestrictedAPI.post(endpoints.oneTimePassword(), data);
export const getFloorDamageTypes = () => RestrictedAPI.get(endpoints.floorDamageTypes());
export const getFloorTypes = () => RestrictedAPI.get(endpoints.floorTypes());
export const getRoomTypes = () => RestrictedAPI.get(endpoints.roomTypes());
export const getPersonValidation = (data: GenericObject) => RestrictedAPI.post(endpoints.personValidation(), data);
export const getStreetNames = (id: string) => RestrictedAPI.get(endpoints.streetNames(id));
export const getWallFinishTypes = () => RestrictedAPI.get(endpoints.wallFinishTyes());
export const getInsuredPerson = (data: any) => RestrictedAPI.post(endpoints.insuredPerson(), data);
export const getContactData = (ucn: string) => RestrictedAPI.get(endpoints.getContactData(ucn));
export const checkContactData = (tempId: string) => RestrictedAPI.get(endpoints.checkContactData(tempId));
